import styled from "react-emotion"

const Sidebar = styled("div")`
    font-family: ${props => props.theme.fontFamily};
    flex-shrink: 0;
    display: inline-flex;
    background-color: ${props => (props.light ? props.theme.backgroundColor : "#2a313b")};
    flex-basis: ${props => (props.wide ? "200px" : "200px")};
    flex-grow: 1;
    overflow-y: auto; /*adds scroll to this container*/
    flex-direction: column;

    @media (max-width: 768px) {
        position: fixed;
        z-index: 1;
        height: 100%;
        top: 0;
        left: ${props => (props.open ? "0px" : props.wide ? "-260px" : "-200px")};
        transition: left 300ms ease;
    }
`
export default Sidebar



// WEBPACK FOOTER //
// ./src/features/studio/ui/Sidebar.js